import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fff6b428"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"16px"} }, "通道账号管理", -1))
const _hoisted_2 = ["onClick"]

import { ref, onMounted, watch } from "vue";
import { message } from "ant-design-vue";
import { channelAccountList, channelAccountCreate } from "@/api/api";
import XTable from "@/components/XATable.vue";
import XDialog from "@/components/XDialog.vue";
import type { FormInstance } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelAcc',
  props: {
  isRefresh: {
    type: Boolean,
    default: false,
  },
},
  emits: ["switchTab"],
  setup(__props, { emit: __emit }) {

const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const emit = __emit;
const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 80 },
  { title: "账号名称", dataIndex: "accountName", key: "accountName" },
  { title: "类型", dataIndex: "type", key: "type", width: 100 },
  {
    title: "通道数量",
    dataIndex: "count",
    key: "count",
    scopedSlots: { customRender: "count" },
    width: 120,
  },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
];

const fetchTableData = async () => {
  loading.value = true;
  try {
    const res = await channelAccountList({
      pageNo: pageNo.value,
      pageSize: pageSize.value,
    });
    tableData.value = res.data.records || [];
    total.value = res.data.total || 0;
  } catch (e) {
    message.error("获取账号列表失败");
  } finally {
    loading.value = false;
  }
};

const addDialogVisible = ref(false);
const addForm = ref({
  accountName: "",
  type: 0,
  //   isSuffix: 1,
  //   url: "",
});
const addFormRef = ref<FormInstance>();
const addLoading = ref(false);
const addFormRules = {
  accountName: [{ required: true, message: "请输入账号名称" }],
  type: [{ required: true, message: "请选择账号类型" }],
  //   isSuffix: [{ required: true, message: "请选择自动通道" }],
  //   url: [{ required: true, message: "请输入通道地址前缀" }],
};
const openAddDialog = () => {
  addDialogVisible.value = true;
  addForm.value = { accountName: "", type: 0 };
  addFormRef.value?.resetFields();
};
const closeAddDialog = () => {
  addDialogVisible.value = false;
};
const handleAddAccount = async () => {
  if (!addFormRef.value) return;
  try {
    await addFormRef.value.validate();
    addLoading.value = true;
    const res = await channelAccountCreate({ ...addForm.value });
    if (res.code === "200") {
      message.success("创建成功");
      closeAddDialog();
      fetchTableData();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示
  } finally {
    addLoading.value = false;
  }
};

const viewChannels = (record: any) => {
  // 查看通道逻辑
  emit("switchTab", record.id);
};

const onPageChange = (page: number) => {
  pageNo.value = page;
  fetchTableData();
};
const props = __props;

onMounted(() => {
  fetchTableData();
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_a_card, { style: {"margin-bottom":"24px","max-width":"500px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: openAddDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode("创建账号")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(XTable, {
      columns: columns,
      "data-source": tableData.value,
      loading: loading.value,
      rowKey: "id",
      bordered: "",
      pagination: false
    }, {
      type: _withCtx(({ record }) => [
        _createElementVNode("span", null, _toDisplayString(record.type === 0 ? "内部" : "外部"), 1)
      ]),
      count: _withCtx(({ record }) => [
        _createElementVNode("a", {
          onClick: ($event: any) => (viewChannels(record))
        }, _toDisplayString(record.count), 9, _hoisted_2)
      ]),
      _: 1
    }, 8, ["data-source", "loading"]),
    _createVNode(_component_a_pagination, {
      current: pageNo.value,
      "page-size": pageSize.value,
      total: total.value,
      onChange: onPageChange,
      style: {"margin-top":"16px","text-align":"right"}
    }, null, 8, ["current", "page-size", "total"]),
    _createVNode(XDialog, {
      visible: addDialogVisible.value,
      title: "创建账号",
      xWidth: "400px",
      onCancel: closeAddDialog,
      onConfirm: handleAddAccount,
      confirmLoading: addLoading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: addForm.value,
          rules: addFormRules,
          ref_key: "addFormRef",
          ref: addFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "账号名称",
              name: "accountName",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addForm.value.accountName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((addForm.value.accountName) = $event)),
                  placeholder: "请输入账号名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "账号类型",
              name: "type",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addForm.value.type,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addForm.value.type) = $event)),
                  style: {"width":"120px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("内部")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("外部")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ]))
}
}

})